/**
 * The demo tenant's sign-ups: a share of each day's customers, wobbled per day, so a
 * day is the same number whichever screen asks (the Overview's Sign-ups tile, its
 * sparkline and the Customers page's Sign-ups panel all read it).
 */

import { wobble } from '../random'
import type { DayTotals } from './engine'

/** Accounts created per customer who bought that day, before the day's wobble. */
const SIGNUPS_PER_CUSTOMER = 0.45

export function signupsOn(seed: number, day: Pick<DayTotals, 'date' | 'newCustomers' | 'returningCustomers'>): number {
  const customers = day.newCustomers + day.returningCustomers
  return Math.round(customers * SIGNUPS_PER_CUSTOMER * wobble(seed, 0.3, 'signups', day.date))
}

export function signupsIn(seed: number, days: readonly DayTotals[]): number {
  return days.reduce((sum, day) => sum + signupsOn(seed, day), 0)
}
